module.exports = __webpack_public_path__ + "static/img/3diamond-tag@3x.c4eb9ecb.png";